import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/home/Home";
import Cart from "./pages/cart/Cart";
import Categories from "./pages/categories/Categories";
import { Contact } from "./pages/contact/Contact";
import Login from "./pages/login/Login";
import Product from "./pages/product-view/Product";

function App() {
  return (
    <>
    <Router>
      <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/product/:id" element={<Product/>} />
      <Route path="/login" element={<Login/>} />
      <Route path="/cart" element={<Cart/>} />
      <Route path="/products" element={<Categories/>} />
      <Route path="/contact" element={<Contact/>} />

      <Route path="*" element={<Home/>} />
      </Routes>
    </Router>
    </>
  );
}

export default App;
